export type IcButtonTypes = "reset" | "submit" | "button";

export type IcButtonVariants =
  | "primary"
  | "secondary"
  | "tertiary"
  | "destructive"
  | "icon"
  | "icon-primary"
  | "icon-secondary"
  | "icon-tertiary"
  | "icon-destructive";
